import logo from './logo.svg';
import React, {useState, useEffect} from "react";

import Terminal from "./components/Terminal"
import Nav from "./components/Nav"

import './App.css';

function App() {
  const [showHelp, setShowHelp] = useState(false);

  return (
    <div className="App">
      <Nav />
      <Terminal showHelp/>
    </div>
  );
}

export default App;
